<template>
    <div class="mx-0 my-0 px-0 py-0 col-12 styleguide">
      <NavbarNew></NavbarNew>
      <b-container fluid="xl" class="mt-5 pb-5">
        <h1>
          Styleguide
        </h1>
        <h6>
          Typografi
        </h6>
        <h1>
          Heading 1
        </h1>
        <h2>
          Heading 2
        </h2>
        <h3>
          Heading 3
        </h3>
        <h4>
          Heading 4
        </h4>
        <p>
          Default font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <p class="text-md">
          Small font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <p class="text-sm">
          Extra small font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <h6>
          Spaltbredd
        </h6>
        <TextContainer>
          The invoice will be sent to the address you have provided. If you alredy have a link to e-invoices via your organisation, the invoice will be sent via that route.
           As part of our enviromental management, we encourage digital invoices. Ensure that you have entered your e-mail if you want to receive the invoice by e-mail.
        </TextContainer>
        <h6>
          Listor
        </h6>
        <TextContainer>
          <p>
            Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum. Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          </p>
          <ul>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
          </ul>
          <p>
            Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum. Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          </p>
          <ol>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
          </ol>
        </TextContainer>
        <h6>
          Färger
        </h6>
        <b-row class="mb-5">
          <b-col>
            <StyleCircle color="#000000" />
          </b-col>
          <b-col>
            <StyleCircle color="#FFFFFF" />
          </b-col>
          <b-col>
            <StyleCircle color="#007D8F" />
          </b-col>
          <b-col>
            <StyleCircle color="#8BCAC1" />
          </b-col>
          <b-col>
            <StyleCircle color="#E4F1F4" />
          </b-col>
        </b-row >
        <b-row class="mb-5">
          <b-col>
            <StyleCircle color="#fedd75" />
          </b-col>
          <b-col>
            <StyleCircle color="#fd5523" />
          </b-col>
          <b-col>
            <StyleCircle color="#3478f6" />
          </b-col>
          <b-col>
            <StyleCircle color="#1c4587" />
          </b-col>
          <b-col>
            <StyleCircle color="#9900ff" />
          </b-col>
        </b-row >
        <b-row class="mb-5">
          <b-col>
            <StyleCircle color="#fff7dd" />
          </b-col>
          <b-col>
            <StyleCircle color="#ffd5ca" />
          </b-col>
          <b-col>
            <StyleCircle color="#ccddfd" />
          </b-col>
          <b-col>
            <StyleCircle color="#c7d1e1" />
          </b-col>
          <b-col>
            <StyleCircle color="#e6c7ff" />
          </b-col>
        </b-row >
        <b-row>
          <b-col>
            <StyleCircle color="#DC3545" />
          </b-col>
        </b-row>
        <h6>
          Länkar
        </h6>
        <TextContainer>
          <a href="#">Länk</a>
        </TextContainer>
        <h6>
          Knappar
        </h6>
        <div class="buttons">
          <span>Default</span>
          <div>
            <b-button variant="primary">Lorem ipsum</b-button> <b-button variant="secondary">Lorem ipsum</b-button> <b-button variant="danger">Lorem ipsum</b-button> <b-button disabled>Lorem ipsum</b-button>
          </div>
        </div>
        <div class="buttons">
          <span>Small</span>
          <div>
            <b-button class="btn-small" variant="primary">Lorem ipsum</b-button> <b-button class="btn-small" variant="secondary">Lorem ipsum</b-button> <b-button class="btn-small" variant="danger">Lorem ipsum</b-button> <b-button class="btn-small" disabled>Lorem ipsum</b-button>
          </div>
        </div>
        <div class="buttons">
          <span>Knapp med ikon</span>
          <div>
            <b-button variant="primary"><i class="fa-light fa-plus mr-1"></i>Create new</b-button> <span><b-button class="btn-small" variant="primary"><i class="fa-light fa-plus mr-1"></i>Create new</b-button></span>
          </div>
        </div>
        <h6>
          Accordion
        </h6>
        <Accordion></Accordion>
        <h6 class="d-none">
          Tabell 1A
        </h6>
        <Table></Table>
        <h6>
          Tabell 1
        </h6>
        <TableB />
        <h6>
          Tabell 2
        </h6>
        <b-form-group class="editable">
          <b-row>
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <b-form-input
              v-model="test4"
              inline
              :class="`col-12 col-md-9`"
              readonly
            />
          </b-row>
          <b-row>
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <b-form-input
            readonly
              v-model="test5"
              inline
              :class="`col-12 col-md-9`"
            />
          </b-row>
          <b-row>
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <b-form-input
              v-model="test6"
              inline
              :class="`col-12 col-md-9` "
              readonly
            />
          </b-row>
          <b-button class="btn-small btn" type="submit" variant="secondary">Edit</b-button>
        </b-form-group>
        <Form></Form>
        <h6>
          Alert
        </h6>
        <div
          class="col-12 col-sm-6 col-md-4 col-xl-4 bg-warning alert pb-2 pt-2 text-center"
        >
        <i class="fa-regular fa-clock mr-1"></i>
          Scheduled 08:00 2021-10-30
        </div>
        <h6>
          Hjälpikon
        </h6>
            <a class="help-text" href="#">
              Delete
              <i class="fa-regular fa-circle-question" v-b-tooltip="'Delete member'"></i>
            </a>
        <h6>
          Charts
        </h6>
        <div class="row mt-5">
          <Chart
            class="col-md-4"
            :sub="0"
            :total="3"
           />
           <Chart
            class="col-md-4"
            :sub="3"
            :total="4"
           />
           <Chart
            class="col-md-4"
            :sub="4"
            :total="4"
           />
        </div>
        <h6>
          Kodfält
        </h6>
        <CodeInput
        :length="6"
        />
        <h6>
          Progress bar
        </h6>
        <b-progress
          variant="info"
          height="1rem"
          :max="60"
          align-v="center"
          class="gdq-progress-bar"
        >
          <b-progress-bar
            align-v="center"
            :value="5"
          />
        </b-progress>
        <div class="text-sm text-right mt-2">
            5 of 60
        </div>
        <h6>
          Skala
        </h6>
        <Scale></Scale>
      </b-container>
    </div>
  </template>
<script>
import Navbar from './Navbar.vue'
import StyleCircle from './styleguide/Circle.vue'
import TextContainer from './TextContainer.vue'
import Accordion from './styleguide/Accordion.vue'
import Table from './styleguide/Table.vue'
import Form from './styleguide/Form.vue'
import ProgressCircle from './ProgressCircle.vue'
import CodeInput from './styleguide/CodeInput.vue'
import Scale from './styleguide/Scale.vue'
import NavbarNew from './styleguide/NavbarNew.vue'
import Chart from './styleguide/Chart.vue'
import TableB from './styleguide/TableB.vue'

export default {
  data () {
    return {
      test4: 'Lorem ipsum',
      test5: 'Lorem ipsum',
      test6: 'Lorem ipsum'
    }
  },
  components: {
    Navbar,
    TextContainer,
    StyleCircle,
    Accordion,
    Table,
    TableB,
    Form,
    ProgressCircle,
    CodeInput,
    Scale,
    Chart,
    NavbarNew
  }
}
</script>
  </style>
